import { examConstants } from '../../constants';
import { examService } from '../../services';
import { notificationActions } from './notification.actions';

const getAll = () => {
  return async (dispatch: any) => {
    const request = () => ({ type: examConstants.GETALL_REQUEST });
    const success = (exams: any) => ({ type: examConstants.GETALL_SUCCESS, payload: exams });
    const failure = (error: any) => ({ type: examConstants.GETALL_FAILURE, payload: error });

    try {
      const exams = await examService.getAll();
      dispatch(success(exams));
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
    }
  };
};

const getAllPaginated = (params: { 
  page: number; 
  limit: number; 
  search?: string; 
  status?: string;
  difficulty?: string;
  created_by?: string;
}) => {
  return async (dispatch: any) => {
    const request = () => ({ type: examConstants.GETALL_REQUEST });
    const success = (data: any) => ({ type: examConstants.GETALL_SUCCESS, payload: data });
    const failure = (error: any) => ({ type: examConstants.GETALL_FAILURE, payload: error });

    dispatch(request());

    try {
      const data = await examService.getAllPaginated(params);
      dispatch(success(data));
      return data; // IMPORTANT: Return data so component can use it
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
      throw error;
    }
  };
};

const getById = (id: number) => {
  return async (dispatch: any) => {
    const request = () => ({ type: examConstants.GETBYID_REQUEST });
    const success = (exam: any) => ({ type: examConstants.GETBYID_SUCCESS, payload: exam });
    const failure = (error: any) => ({ type: examConstants.GETBYID_FAILURE, payload: error });

    dispatch(request());

    try {
      const exam = await examService.getById(id);
      dispatch(success(exam));
      console.log('Exam data loaded:', exam); // Debug log
      return exam; // Return data
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
      throw error;
    }
  };
};

const createExam = (formData: any) => {
  return async (dispatch: any) => {
    dispatch(request(formData));

    try {
      const exam = await examService.create(formData);
      dispatch(success(exam));
      dispatch(notificationActions.addNotification('Tạo đề thi thành công!', 'SUCCESS'));
      return exam;
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
      throw error;
    }
  };

  function request(exam: any) {
    return { type: examConstants.CREATE_REQUEST, payload: exam };
  }
  function success(exam: any) {
    return { type: examConstants.CREATE_SUCCESS, payload: exam };
  }
  function failure(error: any) {
    return { type: examConstants.CREATE_FAILURE, error };
  }
};

const deleteExam = (examId: any) => {
  return async (dispatch: any) => {
    dispatch(request(examId));

    try {
      await examService.remove(examId);
      dispatch(success(examId));
      dispatch(notificationActions.addNotification('Xóa đề thi thành công!', 'SUCCESS'));
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
    }
  };

  function request(examId: number) {
    return { type: examConstants.DELETE_REQUEST, payload: examId };
  }
  function success(examId: number) {
    return { type: examConstants.DELETE_SUCCESS, payload: examId };
  }
  function failure(error: any) {
    return { type: examConstants.DELETE_FAILURE, error };
  }
};

const updateExam = (formData: any) => {
  return async (dispatch: any) => {
    dispatch(request(formData));

    try {
      const updatedExam = await examService.update(formData);
      dispatch(success(updatedExam));
      dispatch(notificationActions.addNotification('Cập nhật đề thi thành công!', 'SUCCESS'));
      return updatedExam;
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
      throw error;
    }
  };

  function request(exam: any) {
    return { type: examConstants.UPDATE_REQUEST, payload: exam };
  }
  function success(exam: any) {
    return { type: examConstants.UPDATE_SUCCESS, payload: exam };
  }
  function failure(error: any) {
    return { type: examConstants.UPDATE_FAILURE, error };
  }
};

const addQuestions = (examId: number, data: { method: 'manual' | 'filter' | 'auto'; question_ids?: number[]; filters?: any; count?: number }) => {
  return async (dispatch: any) => {
    dispatch(request());

    try {
      const result = await examService.addQuestions(examId, data);
      dispatch(success(result));
      // No notification here - it's part of exam creation flow
      return result;
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
      throw error;
    }
  };

  function request() {
    return { type: examConstants.ADD_QUESTIONS_REQUEST };
  }
  function success(result: any) {
    return { type: examConstants.ADD_QUESTIONS_SUCCESS, payload: result };
  }
  function failure(error: any) {
    return { type: examConstants.ADD_QUESTIONS_FAILURE, error };
  }
};

const removeQuestion = (examId: number, questionId: number) => {
  return async (dispatch: any) => {
    dispatch(request());

    try {
      await examService.removeQuestion(examId, questionId);
      dispatch(success({ examId, questionId }));
      dispatch(notificationActions.addNotification('Xóa câu hỏi thành công!', 'SUCCESS'));
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
      throw error;
    }
  };

  function request() {
    return { type: examConstants.REMOVE_QUESTION_REQUEST };
  }
  function success(data: any) {
    return { type: examConstants.REMOVE_QUESTION_SUCCESS, payload: data };
  }
  function failure(error: any) {
    return { type: examConstants.REMOVE_QUESTION_FAILURE, error };
  }
};

const duplicate = (examId: number, title?: string) => {
  return async (dispatch: any) => {
    dispatch(request());

    try {
      const newExam = await examService.duplicate(examId, title);
      dispatch(success(newExam));
      dispatch(notificationActions.addNotification('Sao chép đề thi thành công!', 'SUCCESS'));
      return newExam;
    } catch (error: any) {
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
      throw error;
    }
  };

  function request() {
    return { type: examConstants.DUPLICATE_REQUEST };
  }
  function success(exam: any) {
    return { type: examConstants.DUPLICATE_SUCCESS, payload: exam };
  }
  function failure(error: any) {
    return { type: examConstants.DUPLICATE_FAILURE, error };
  }
};

export const examActions = {
  getAll,
  getAllPaginated,
  getById,
  createExam,
  updateExam,
  deleteExam,
  addQuestions,
  removeQuestion,
  duplicate,
};
